import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { UnidadesComponent } from '../unidades/unidades.component';

@Injectable({
	providedIn: 'root'
})
export class VeiculoService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: HttpClient) { }

	getVeiculos(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/' + id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getVeiculosByUnidade(unidade_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/unidade/' + unidade_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/veiculos', {
				unidade_id: data.unidade_id,
				cliente_id: data.cliente_id,
				veiculo_numero: data.veiculo_numero,
				veiculo_placa: data.veiculo_placa,
				veiculo_chassi: data.veiculo_chassi,
				veiculo_renavam: data.veiculo_renavam,
				tipo_veiculo_id: data.tipo_veiculo_id,
				especialidade_veiculo_id: data.especialidade_veiculo_id,
				cor_veiculo_id: data.cor_veiculo_id,
				marca_veiculo_id: data.marca_veiculo_id,
				modelo_veiculo_id: data.modelo_veiculo_id,
				veiculo_ano_fabricacao: data.veiculo_ano_fabricacao,
				veiculo_ano_modelo: data.veiculo_ano_modelo,
				veiculo_historico_descricao: data.veiculo_historico_descricao,
				quilometragem: data.quilometragem,
				veiculo_situacao: 'C',
				veiculo_isento: data.veiculo_isento,
				veiculo_checklist: data.veiculo_checklist,
				veiculo_status: data.veiculo_status == false ? 'N' : 'S',
				unidades: data.unidades
			})
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/veiculos/' + data.veiculo_id, {
				unidade_id: data.unidade_id,
				cliente_id: data.cliente_id,
				veiculo_numero: data.veiculo_numero,
				veiculo_placa: data.veiculo_placa,
				veiculo_chassi: data.veiculo_chassi,
				veiculo_renavam: data.veiculo_renavam,
				tipo_veiculo_id: data.tipo_veiculo_id,
				especialidade_veiculo_id: data.especialidade_veiculo_id,
				cor_veiculo_id: data.cor_veiculo_id,
				marca_veiculo_id: data.marca_veiculo_id,
				modelo_veiculo_id: data.modelo_veiculo_id,
				veiculo_ano_fabricacao: data.veiculo_ano_fabricacao,
				veiculo_ano_modelo: data.veiculo_ano_modelo,
				veiculo_historico_descricao: data.veiculo_historico_descricao,
				quilometragem: data.quilometragem,
				veiculo_isento: data.veiculo_isento,
				veiculo_checklist: data.veiculo_checklist,
				veiculo_status: data.veiculo_status == false ? 'N' : 'S',
				unidades: data.unidades
			})
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/veiculos/' + id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getVeiculosNaoIsento() {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/naoIsento')
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getVeiculosManutencao(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/manutencao/' + usuario_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getVeiculosByUsuario(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/usuario/' + usuario_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	testeToken(usuario_id) {
		console.log("[veiculoService begin]");
		this.http.get(this.url + '/veiculos/usuario/' + usuario_id).subscribe(resp => {
			console.log(resp);
		});		
		console.log("[veiculoService End]");
	}

	getVeiculosActiveByUsuario(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/active/' + usuario_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getVeiculosByProfissional(profissional_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/profissional/' + profissional_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getVeiculosManutencoes(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/manutencoes/' + usuario_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getVeiculosDashboard(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/dash/' + usuario_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getRelatorioVeiculos(usuario_id){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/relatorio/' + usuario_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getByTipoVeiculo(unidade_id, tipo){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/tipo/' + unidade_id + '/' + tipo)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getByTipoVeiculoFiltro(unidade_id){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/tipo/' + unidade_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}	

	getAmbulancias(usuario_id){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/ambulancias/' + usuario_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
	getMotos(usuario_id){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/motos/' + usuario_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getByVeiculoClienteUnidade(unidade_id,cliente_id){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/clienteUnidade/' + unidade_id + '/' + cliente_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


	getByVeiculoUnidadeEspecialidade(unidade_id,especialidade){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/veiculosUnidadeEspecialidade/' + unidade_id + '/' + especialidade)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getByVeiculoClienteUnidadeEspecialidade(cliente_id,unidade_id,especialidade){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/veiculos/veiculosClienteUnidadeEspecialidade/' + cliente_id + '/' + unidade_id + '/' + especialidade)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

}
